module.exports = __webpack_public_path__ + "static/media/website-15.d57ed810.png";